import { map } from 'lodash';
import type { IOrganizationFeatureClientPortalDisplay } from './OrganizationFeatureClientPortalDisplay.interface';

export default class OrganizationFeatureClientPortalDisplay
  implements IOrganizationFeatureClientPortalDisplay {
  clientProfileFullVersion: {
    visible: boolean,
    wizard: Array<number>
  };

  clientProfileCustomVersion: {
    visible: boolean,
    wizard: Array<number>
  };

  privacy: {
    visible: boolean,
    url: string
  };

  showDealStatusBar: boolean;
  showFactFind: boolean;
  sidebarDealEstimatedCloseDate: boolean;
  sidebarDealProfessionalAdviceDetails: boolean;
  sidebarDealSummaryNotes: boolean;

  sidebarOverviewVideo: {
    visible: boolean,
    url: string
  };

  static build = (data: IOrganizationFeatureClientPortalDisplay) =>
    new OrganizationFeatureClientPortalDisplay(data);

  static blank = () => new OrganizationFeatureClientPortalDisplay();

  /**
   * Constructor
   * @param {IOrganizationFeatureClientPortalDisplay} data
   */
  constructor(data?: IOrganizationFeatureClientPortalDisplay) {
    // TODO: sidebarDealEstimatedCloseDate is legacy structure
    this.sidebarDealEstimatedCloseDate = data?.sidebarDealEstimatedCloseDate === true;
    // TODO: sidebarDealEstimatedCloseDate is legacy structure
    // TODO: sidebarDealProfessionalAdviceDetails is legacy structure
    this.sidebarDealProfessionalAdviceDetails =
      data?.sidebarDealProfessionalAdviceDetails === true;
    // TODO: sidebarDealProfessionalAdviceDetails is legacy structure
    // TODO: sidebarDealSummaryNotes is legacy structure
    this.sidebarDealSummaryNotes = data?.sidebarDealSummaryNotes === true;
    // TODO: sidebarDealSummaryNotes is legacy structure
    this.showDealStatusBar = data?.showDealStatusBar === true;
    this.showFactFind = data?.showFactFind === true;
    this.sidebarOverviewVideo = {
      visible: data?.sidebarOverviewVideo.visible === true,
      url: data?.sidebarOverviewVideo.url || undefined
    };
    this.privacy = {
      visible: data?.privacy.visible === true,
      url: data?.privacy.url || undefined
    };
    // TODO: clientProfileFullVersion is legacy structure
    this.clientProfileFullVersion = {
      visible: data?.clientProfileFullVersion.visible === true,
      wizard: map(data?.clientProfileFullVersion.wizard, (obj) => parseInt(obj, 10))
    };
    // TODO: clientProfileFullVersion is legacy structure
    // TODO: clientProfileCustomVersion is legacy structure
    this.clientProfileCustomVersion = {
      visible: data?.clientProfileCustomVersion.visible === true,
      wizard: map(data?.clientProfileCustomVersion.wizard, (obj) => parseInt(obj, 10))
    };
    // TODO: clientProfileCustomVersion is legacy structure
  }
}
